import { Suspense } from 'react';
import { Skeleton } from '@sara/ui/components/skeleton';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { InterviewAttemptsContainerContent } from './InterviewAttemptsContainerContent';
import type { InterviewAttemptsContainerProps } from './types';

export type { InterviewAttemptsContainerProps };

export function InterviewAttemptsContainer(props: InterviewAttemptsContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense
        fallback={
          <div data-testid="attempts-loading" className="space-y-3">
            <Skeleton className="h-9 w-2/3 rounded-lg" />
            <Skeleton className="h-16 w-3/4 rounded-lg" />
            <Skeleton className="ml-auto h-16 w-3/4 rounded-lg" />
            <Skeleton className="h-16 w-3/4 rounded-lg" />
          </div>
        }
      >
        <InterviewAttemptsContainerContent {...props} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
